/* FurStra: swipe through product photos (main gallery on product pages).
   Photos sit side-by-side and snap into place when swiped.
   Thumbnails still work - tapping one slides to that photo. */
(function () {
  function init(main) {
    if (main.dataset.fsSwipe) return;
    var slides = Array.prototype.slice.call(main.querySelectorAll('[data-blocky-product-media]'));
    if (slides.length < 2) return;
    main.dataset.fsSwipe = '1';
    var root = main.closest('blocky-featured-product');
    var fromSwipe = false, timer;

    function indexOfActive() {
      for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i;
      return 0;
    }
    function goTo(i, smooth) {
      main.scrollTo({ left: i * main.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    }

    var mo = new MutationObserver(function () {
      if (fromSwipe) return;
      var i = indexOfActive();
      if (Math.round(main.scrollLeft / main.clientWidth) !== i) goTo(i, true);
    });
    slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });

    main.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.max(0, Math.min(slides.length - 1, Math.round(main.scrollLeft / main.clientWidth)));
        if (i === indexOfActive()) return;
        fromSwipe = true;
        var id = slides[i].dataset.blockyProductMedia;
        if (root && typeof root.activateMedia === 'function') root.activateMedia(id);
        else slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        setTimeout(function () { fromSwipe = false; }, 0);
      }, 80);
    }, { passive: true });

    var dots = document.createElement('div');
    dots.className = 'fs-gallery-dots';
    dots.setAttribute('aria-hidden', 'true');
    slides.forEach(function (s, i) {
      var d = document.createElement('span');
      if (i === 0) d.className = 'is-on';
      dots.appendChild(d);
    });
    var wrap = main.closest('.blocky-featured-product__media-wrap') || main;
    wrap.insertAdjacentElement('afterend', dots);
    var dotEls = dots.children;
    new MutationObserver(function () {
      var i = indexOfActive();
      for (var n = 0; n < dotEls.length; n++) dotEls[n].className = n === i ? 'is-on' : '';
    }).observe(main, { subtree: true, attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', function () { goTo(indexOfActive(), false); });
  }

  function run() {
    document.querySelectorAll('.blocky-featured-product__main').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
